import VideoPlayer from 'CoreComponents/videoPlayer';

const CLASS_NAME = {
  PROGRESSIVE_VIDEO: 'progressive-video'
};

const SELECTOR = {
  PROGRESSIVE_VIDEO_ELEMENT: '[id^=progressiveVideo]'
};

class ProgressiveVideoLoader {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to progressively load a background video.
   * */
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.videoElement = this.elementRef.querySelector(SELECTOR['PROGRESSIVE_VIDEO_ELEMENT']);

    this.onLoad = this.onLoad.bind(this);

    this._setup();
  }

  /**
   * Load the video and setup the JWPlayer.
   * */
  load() {
    if (window.jwplayer) {
      this._createVideoPlayer();
      this._addEventListeners();
    }
  }

  // Event Handlers

  /**
   * Event callback to be triggered after the JWPlayer has been setup.
   * */
  onLoad(event) {
    const { setupTime } = event;
    const moderationDurationTime = (setupTime / 1000) * 2;
    const durationTime = moderationDurationTime < 0.5 ? moderationDurationTime : 0.5;

    this.overlay.style.transitionDuration = `${durationTime}s`;
    this.overlay.style.backgroundColor = '#000';
    this.overlay.style.opacity = 0;
  }

  // Private

  /**
   * Set-up the ProgressiveVideoLoader.
   *  1) Append the overlay element to load the container of the video player.
   * */
  _setup() {
    this.elementRef.classList.add(CLASS_NAME['PROGRESSIVE_VIDEO']);
    this.overlay = this._createOverlay();
  }

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.videoPlayer.onReady(this.onLoad);
  }

  /**
   * Creates the overlay.
   *
   * @return {Element} - HTML node for the overlay.
   * */
  _createOverlay() {
    const overlay = document.createElement('div');

    overlay.setAttribute('class', 'progressive-video--overlay');
    this.elementRef.prepend(overlay);

    return overlay;
  }

  /**
   * Setup the JWPlayer.
   * */
  _createVideoPlayer() {
    const videoOptions = {
      file: this.videoElement.dataset.videoFile,
      title: this.videoElement.dataset.videoTitle,
      mediaid: this.videoElement.dataset.videoUuid,
      type: this.videoElement.dataset.videoType,
      controls: false
    };

    if (this.videoElement.dataset.videoPoster) {
      Object.assign(videoOptions, {
        image: this.videoElement.dataset.videoPoster
      });
    }

    this.videoPlayer = new VideoPlayer(this.videoElement, videoOptions);
  }
}

export default ProgressiveVideoLoader;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/progressiveVideoLoader/index.js